import styled, { css } from 'styled-components';

export const StyledDivider = styled.hr`
  background-color: ${({ theme }) => theme.colors.mediumGrey};
  border: none;
  margin: 0;
  ${({ orientation }) => orientation === 'horizontal' && css`
    width: ${({ offset }) => offset ? `calc(100% - ${offset}px)` : `100%`};
    height: 1px;  
    margin: 0 auto;
  `};
  ${({ orientation }) => orientation === 'vertical' && css`
    width: 1px;
    height: ${({ offset }) => offset ? `calc(100% - ${offset}px)` : `100%`};
    ${({ flexItem }) => flexItem && css`
      height: auto;
      align-self: stretch;
    `};
  `};
  ${({ customStyle }) => customStyle && customStyle};
`;